import React from 'react';
import { get } from 'lodash';

import { FIELD_PATHS, YES_NO_OPTIONS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { useAnalytics } from '@funnels/providers';
import { AssetEntityIndex } from '@funnels/types';

import { HelpTooltip } from '../../Common';
import { RadioButtonsField } from '../../Fields';
import { EditableViewProps } from '../types';

interface FixedPriceContractEditableViewProps extends EditableViewProps, AssetEntityIndex {}

export const FixedPriceContractEditableView = (props: FixedPriceContractEditableViewProps) => {
  const { tracking } = useAnalytics();
  const { assetIndex, isOptional } = props;
  const [formValues] = useFormValues();
  const selectedValue = get(formValues, FIELD_PATHS.ASSET_IS_FIXED_PRICE_CONTRACT(assetIndex));
  const tooltipContent =
    'A fixed price contract is a building contract with a fixed lump sum price for all specified building works.';

  const handleTracking = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = e.target.value;
    const selection =
      YES_NO_OPTIONS.find((option) => {
        return option.value === selectedValue;
      })?.label || '';
    tracking?.radio({ title: 'This is a fixed price contract', selection, position: 'Property - Current Loan' });
  };

  return (
    <RadioButtonsField
      label="This is a fixed price contract"
      name={FIELD_PATHS.ASSET_IS_FIXED_PRICE_CONTRACT(assetIndex)}
      direction="row"
      radios={YES_NO_OPTIONS}
      labelAfter={<HelpTooltip content={tooltipContent} />}
      onChange={handleTracking}
      {...{ isOptional, selectedValue }}
    />
  );
};
